import { OrderedMap } from "immutable";

import castDates from "utils/castDates";

import {
  GET_CURATION_LIST_SUCCEEDED,
  GET_CURATION_LIST_NEXT_PAGE_SUCCEEDED,
} from "curation/actions/list";

const processNewResults = results => {
  return OrderedMap(
    results.reduce((result, item) => {
      return {
        ...result,
        [item.id]: castDates(item),
      };
    }, {})
  );
};

export default (state = { items: {} }, action) => {
  switch (action.type) {
    case GET_CURATION_LIST_SUCCEEDED:
      // add new content and overwrite stale content in state
      return {
        items: processNewResults(action.payload.results),
        meta: { response: action.payload },
      };
    case GET_CURATION_LIST_NEXT_PAGE_SUCCEEDED:
      // add new content to items
      return {
        items: state.items.merge(processNewResults(action.payload.results)),
        meta: { response: action.payload },
      };
    default:
      return state;
  }
};
